"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProvider = void 0;
var did_resolver_interface_1 = require("@ew-did-registry/did-resolver-interface");
var ethers_1 = require("ethers");
var JsonRpcProvider = ethers_1.providers.JsonRpcProvider, IpcProvider = ethers_1.providers.IpcProvider;
function getProvider(settings) {
    if (settings === void 0) { settings = { type: did_resolver_interface_1.ProviderTypes.HTTP }; }
    var type = settings.type, _a = settings.uriOrInfo, uriOrInfo = _a === void 0 ? 'http://localhost:8544' : _a, path = settings.path, network = settings.network;
    switch (type) {
        case did_resolver_interface_1.ProviderTypes.HTTP:
            return new JsonRpcProvider(uriOrInfo, network);
        case did_resolver_interface_1.ProviderTypes.IPC:
            return new IpcProvider(path, network);
        default:
            throw new Error('Unsupported provider');
    }
}
exports.getProvider = getProvider;
//# sourceMappingURL=providers.js.map